<template>
  <div class="modal-dialog" @click.self="closeByClickingBorder">
    <div class="modal-dialog__wrapper" @click.self="closeByClickingBorder">
      <slot name="header">
        <Header :title="title" :subtitle="subtitle" @close="close" />
      </slot>

      <slot v-if="isDynamic ? data != null : true" :data="data" />

      <slot name="loader" v-if="isDynamic ? data == null : false">
        <Loader />
      </slot>

      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Header from './modal/Header.vue'

import AutoCloseMixin from '@/components/AutoCloseMixin'
import BodyFreezerMixin from '@/components/BodyFreezerMixin'
import Loader from '@/components/Loader.vue'

@Component({
  mixins: [
    BodyFreezerMixin,
    AutoCloseMixin,
  ],
  components: {
    Header,
    Loader,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    isDynamic: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    closeByClickingOutside: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
})
export default class ModalRoot extends Vue {
  data = null

  mounted () {
    if (this.isDynamic) {
      this.$emit('load', data => { this.data = data })
    }
    this.freezeBody()
  }
  
  destroyed () {
    this.unfreezBody()
  }

  closeByClickingBorder () {
    if (this.closeByClickingOutside) {
      this.close()
    }
  }

  close () {
    this.unfreezBody()
    this.$emit('close')
  }
}
</script>

<style lang="scss">
@import './consts.scss';

.modal-dialog {
  overflow-x: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: $modal-z-index;
  outline: 0;
  background-color: rgba(0, 92, 169, 0.9);
  margin: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  
  &__wrapper {
    padding: 0 10px;
    width: 100%;
    max-width: 1260px;
    margin: 20px auto 0;
    padding-bottom: 30px;

    @include media(desktop) {
      margin-top: 45px;
      padding-bottom: 75px;
    }
  }
}
.modal-dialog__content {
  background-color: #fff;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  padding: 60px 30px;
}
.modal-dialog--small .modal-dialog__wrapper {
  max-width: 630px;
}
.modal-dialog--small .modal-dialog__content {
  min-height: 400px;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalRoot.vue